import {AdminRole} from './middleware/roles'
import {AdminRoutes} from './routes/admin'
import {keepBlankModeToStaff} from '../utils/blankMode'

const Home = () => import(/* webpackChunkName: "home" */ '../views/Home.vue');
const App = () => import(/* webpackChunkName: "home" */ './../../src/App.vue');
const Blank = () => import(/* webpackChunkName: "home" */ '../views/Blank.vue');
const TwoFactor = ()  => import(/* webpackChunkName: "home" */ '../views/TwoFactor.vue');
function loadView(folder,view) {
    return () => import(/* webpackChunkName: "view-[request]" */ `../views/${folder}/${view}.vue`)
}

export default [
    {path: '/', component: App,
        children: [
            {path: '', name: 'home', component: Home},
            {path: '/candidates', name: 'candidates', props: { filtering: false }, component: loadView('candidates','Candidates')},
            {path: '/candidates/create', name: 'candidate-create',component: loadView('candidates','CandidateCreate')},
            {path: '/candidates/:id', name: 'candidate-details', props: true, component: loadView('candidates','CandidateDetails')},
            {path: '/candidates/:id/appointment', name: 'candidate-appointment', props: true, component: loadView('candidates','CandidateDetails')},

            {path: '/customers', name: 'customers', component: loadView('customers','Customers')},
            {path: '/customers/create', name: 'customer-create', component: loadView('customers','CustomerCreate')}, // JUST ADMINS
            {path: '/customers/:id', name: 'customer-details', props: true, component: loadView('customers','CustomerDetails')},
            {path: '/customer-visits', name: 'customer-visits', component: loadView('customers','CustomerVisitsOverview')},

            {path: '/roles', name: 'roles', component: loadView('roles','Roles')},
            {path: '/roles/create', name: 'role-create', component: loadView('roles','RoleCreate')},

            {path: '/users', name: 'users', component: loadView('users','Users')},
            {path: '/users/create', name: 'user-create', component: loadView('users','UserCreate')},

            // Hour app
            {path: '/hours', name: 'hours', component: loadView('hours','Hours')},
            {path: '/hours/:date', name: 'hours-date', component: loadView('hours','Hours')},
            {path: '/documents', name: 'documents', component: loadView('documents','Documents')},
            {path: '/documents/:employment/:category/:name', name: 'documents-category-user', component: loadView('documents','DocumentView')},
            {path: '/leave-requests/:employment/:name', name: 'leave-requests-user', component: loadView('leave-requests','UserLeaves')},
            {path: '/archived-chats/:employment/:name', name: 'archived-chats-user', component: loadView('archived-chats','UserArchivedChats')},
            {path: '/chat', name: 'chat', component: loadView('chat','Chat')},
            {path: '/configurations', name: 'configuration', component: loadView('configuration','Configuration')},
            {path: '/configurations/:id/:name', name: 'configuration-view', component: loadView('configuration','ConfigurationView')},
            {path: '/notifications', name: 'notifications', component: loadView('notifications','NotificationsView')},
            {path: '/metrics', name: 'metrics', component: loadView('metrics','MetricsView')},

            {path: '/vacancies', name: 'vacancies', props: true, component: loadView('vacancies','Vacancies')},
            {path: '/vacancies/create', name: 'vacancy-create', component: loadView('vacancies','VacancyCreate')},
            {path: '/vacancies/:id', name: 'vacancy-details', props: true, component: loadView('vacancies','VacancyDetails')},

            {path: '/admin/experiences', name: 'experiences', component: loadView('experiences','Experiences')}, // JUST ADMINS
            {path: '/admin/cost-centers', name: 'costCenters', component: loadView('costCenters','CostCenters')}, // JUST ADMINS
            {path: '/admin/certificates', name: 'certificates', component: loadView('certificates','Certificates')}, // JUST ADMINS
            {path: '/admin/educations', name: 'educations', component: loadView('educations','Educations')}, // JUST ADMINS
            {path: '/admin/email-config', name: 'email-config', component: loadView('admin','EmailConfig')}, // JUST ADMINS
            {path: '/appointments', name: 'appointments', component: loadView('appointments','appointments')},

            {path: '/blacklist', name: 'blacklist', component: loadView('blacklist','Blacklist')},

            {path: '/quitters', name: 'quitters', props: { filtering: false }, component: loadView('quitters','Quitters')},

            {path: '/smsHistory', name: 'smsHistory', component: loadView('sms','History')},
            {path: '/pools', name: 'pools', component: loadView('pools','pools')},
            {path: '/mailinglist', name: 'mailinglist', component: loadView('mailinglist','mailinglist')},
            {path: '/import', name: 'import', component: loadView('import','import')},
            {path: '/analytics', name: 'analytics', component: loadView('analytics','Analytics')},

            {path: '/contracts', name: 'contracts', component: loadView('contracts','Contracts')},
            {path: '/contracts/add', name: 'add-contracts', component: loadView('contracts','AddContract')},
            {path: '/contracts/:id', name: 'edit-contracts', component: loadView('contracts','EditContract')},
        ]
    },
    {path: '/callback', name: 'cb', component: TwoFactor},

    {path: '/blank', name: 'blank', component: Blank, beforeEnter: keepBlankModeToStaff},


    AdminRoutes,
    {
        path: '*',
        redirect: '/'
    }
]